import { TirPmStatusBgEnum, TirPmStatusTextEnum } from "tir-components";

export default class DropdownItemModel {
  Id:string;
  Name: string;
  IsDoted: boolean;
  IsBordered: boolean;
  Bg: TirPmStatusBgEnum;
  Color: TirPmStatusTextEnum;
  IsSelect:boolean;
  constructor(obj?: Partial<DropdownItemModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
